import React from "react";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";

export default function Input(props) {
	const {
		as,
		disabled,
		feedback,
		feedbackType,
		id,
		label = "",
		max,
		min,
		name,
		onBlur = () => {},
		onChange = () => {},
		onKeyDown = () => {},
		required,
		step,
		style,
		type = "text",
		value,
	} = props;

	let _feedback = "";
	if (min !== undefined) {
		if (value < min) {
			_feedback += `The minimum value allowed is ${min}`;
		}
	}
	if (max !== undefined) {
		if (value > max) {
			_feedback += `The maximum value allowed is ${max}`;
		}
	}

	return (
		<>
			{/* <InputGroup size="sm" className="mb-3"> */}
			{/* <InputGroup.Text id={label}>{label}</InputGroup.Text> */}
			<FloatingLabel controlId={label} label={`${label} ${required ? "*" : ""}`} className="g-0">
				<Form.Control
					// id={id}
					aria-describedby={label}
					aria-label={label}
					as={as}
					controlid={id}
					disabled={disabled}
					max={max}
					min={min}
					name={name}
					onBlur={onBlur}
					onChange={onChange}
					onKeyDown={onKeyDown}
					placeholder={label}
					required={required}
					step={step}
					style={style}
					type={type}
					value={value}
				/>
				{(feedback || _feedback) && (
					<Form.Control.Feedback type="invalid">{_feedback || feedback}</Form.Control.Feedback>
				)}
			</FloatingLabel>
			{/* </InputGroup> */}
		</>
	);
}
